export default __webpack_public_path__ + "static/media/realTimeUpdates.6a175dd6.png";